<template>
    <div>
        <b-icon :class="'ikon '+iconName" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.6" variant="light"></b-icon>
    </div>
    <!--<svg class="bi" width="32" height="32" fill="currentColor">
        <use :xlink:href="'../../../assets/medez/fonts/MedEZ.svg#'+iconName" />
    </svg>-->
  
</template>

<script>

export default {
  name: 'Ikon',
  props:{iconName:String},
   
};
</script>


